// Paleta y metadatos de los estados de un turno de Recepción.
// Unifica lo que antes vivía triplicado como ESTADOS (TurneroPage),
// ESTADOS_PANEL (PanelDiario) y ESTADOS_CONFIG (AtencionPage), para que
// las tres pantallas usen exactamente los mismos colores e íconos.
//
// El estado ASISTIO tiene dos etiquetas válidas según el contexto:
// "Asistió" (Turnero, historial) y "En espera" (PanelDiario/Atención,
// mientras el cliente aguarda ser atendido). Ambas se exponen; cada
// página elige la que corresponde a su copy actual — esto es texto de
// producto, no una decisión estética, así que no se unifica.

export const ESTADOS_TURNO = {
    CREADO: {
        etiqueta: 'Creado',
        bg: '#dbeafe', border: '#93c5fd', text: '#1e40af', riel: '#3b82f6',
        icono: 'bi-plus-circle-fill',
    },
    PENDIENTE: {
        etiqueta: 'Pendiente',
        bg: '#fef9c3', border: '#fde047', text: '#854d0e', riel: '#eab308',
        icono: 'bi-hourglass-split',
    },
    CONFIRMADO: {
        etiqueta: 'Confirmado',
        bg: '#dcfce7', border: '#86efac', text: '#166534', riel: '#22c55e',
        icono: 'bi-check-circle-fill',
    },
    REPROGRAMADO: {
        etiqueta: 'Reprogramado',
        bg: '#ffedd5', border: '#fdba74', text: '#9a3412', riel: '#f97316',
        icono: 'bi-arrow-repeat',
    },
    CANCELADO: {
        etiqueta: 'Cancelado',
        bg: '#f1f5f9', border: '#94a3b8', text: '#475569', riel: '#94a3b8',
        icono: 'bi-slash-circle-fill',
    },
    ASISTIO: {
        etiqueta: 'Asistió',
        etiquetaEspera: 'En espera',
        bg: '#166534', border: '#166534', text: '#fff', riel: '#166534',
        icono: 'bi-check-circle-fill',
    },
    NO_ASISTIO: {
        etiqueta: 'No asistió',
        bg: '#fee2e2', border: '#fca5a5', text: '#991b1b', riel: '#ef4444',
        icono: 'bi-x-circle-fill',
    },
    EN_CURSO: {
        etiqueta: 'En curso',
        bg: '#fef3c7', border: '#fbbf24', text: '#92400e', riel: '#f59e0b',
        icono: 'bi-play-circle-fill',
    },
    EN_ANSES: {
        etiqueta: 'En ANSES',
        bg: '#e0f2fe', border: '#7dd3fc', text: '#075985', riel: '#0ea5e9',
        icono: 'bi-building',
    },
    FINALIZADO: {
        etiqueta: 'Finalizado',
        bg: '#dcfce7', border: '#4ade80', text: '#166534', riel: '#22c55e',
        icono: 'bi-check-circle-fill',
    },
};

// Orden y subconjunto de estados que usa el flujo de Turnero (leyenda,
// botones de cambio de estado). No incluye EN_CURSO/EN_ANSES/FINALIZADO
// porque esos son propios del flujo de Atención, no del turno en sí.
export const ESTADOS_TURNERO = [
    'CREADO', 'PENDIENTE', 'CONFIRMADO', 'REPROGRAMADO', 'CANCELADO', 'ASISTIO', 'NO_ASISTIO',
].map((valor) => ({ valor, ...ESTADOS_TURNO[valor] }));

// El sobreturno no es un estado — es un atributo que se superpone
// visualmente al color del estado (borde punteado + etiqueta violeta).
export const ESTILO_SOBRETURNO = { border: '#7c3aed', text: '#6d28d9', bg: '#f5f3ff' };

export function estiloEstado(estado) {
    const clave = String(estado || '').trim().toUpperCase();
    return ESTADOS_TURNO[clave] || ESTADOS_TURNO.CREADO;
}
